export const CONSTRUCTION_TYPES = [
  'Commercial',
  'Institutional',
  'Industrial'
];

export const WORK_NATURES = [
  'Interior Renovation',
  'Exterior Renovation',
  'New Construction'
];

// Directives : une directive « À évaluer » depuis plus de N jours (a compter de
// sa date de reception, date_directive) est signalee en retard. Calcul cote app
// (utils/directiveAlerts.js), aucune colonne en base.
export const DIRECTIVE_PENDING_ALERT_DAYS = 14;
